export default __webpack_public_path__ + "media/images/about_us/work-737984818d6fa047883974e46717ca2c.png";